import { selectCommitmentItems } from 'legacy/lut/features/partner360/commitment'
import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

export const selectCommitmentItemsByProgramType = createSelector(
  [selectCommitmentItems, selectConfigurationState],
  (commitmentItems, { programType }) => {
    return commitmentItems.filter((el) => el.ProgramType === programType)
  }
)
